import * as React from 'react';
import { createPortal } from 'react-dom';
import { st, classes } from './MobileDrawer.st.css';
import { Modal } from '../internal/Modal';
import {
  MobileDrawerProps,
  MobileDrawerState,
  MobileDrawerDefaultProps,
  MobileDrawerPosition,
} from './types';

/** MobileDrawers provide access to destinations and functionality menus, such as Action Menus, Filter Dropdown etc. This component should be used on mobile only. */
export class MobileDrawer extends React.Component<
  MobileDrawerProps,
  MobileDrawerState
> {
  state = {
    visible: false,
  };

  static displayName = 'MobileDrawer';
  static defaultProps: MobileDrawerDefaultProps = {
    isOpen: false,
    onRequestClose: () => {},
    position: MobileDrawerPosition.Bottom,
    isFullScreen: false,
    appendToBody: false,
  };

  _onRequestClose() {
    this.setState({ visible: false });
    this.props.onRequestClose();
  }

  componentDidMount() {
    if (this.props.isOpen && !this.state.visible) {
      setTimeout(() => {
        this.setState({ visible: true });
      }, 0);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.isOpen && !this.state.visible) {
      setTimeout(() => {
        this.setState({ visible: true });
      }, 0);
    }

    if (prevProps.isOpen && !this.props.isOpen) {
      this.setState({ visible: false });
    }
  }

  render() {
    const {
      isOpen,
      children,
      'aria-label': ariaLabel,
      'aria-labelledby': ariaLabelledBy,
      'aria-describedby': ariaDescribedBy,
      className,
      position,
      isFullScreen,
      appendToBody,
    } = this.props;
    const { visible } = this.state;

    const mobileDrawerContent = (
      <div className={st(classes.root, className)} data-hook={this.props['data-hook']}>
        <Modal isOpen={isOpen} onRequestClose={() => this._onRequestClose()}>
          <div
            className={st(classes.contentWrapper, {
              visible,
              position,
              fullScreen: isFullScreen,
            })}
            role="dialog"
            aria-modal="true"
            aria-label={ariaLabel}
            aria-labelledby={ariaLabelledBy}
            aria-describedby={ariaDescribedBy}
          >
            {children}
          </div>
        </Modal>
      </div>
    );

    return appendToBody && typeof document !== 'undefined'
      ? createPortal(mobileDrawerContent, document.body)
      : mobileDrawerContent;
  }
}
